export default __webpack_public_path__ + "static/media/sg3.1e53d011.png";